import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { encodeBasketQr } from './digital-menu-basket-qr';
import type { DigitalMenuBasketLine } from './digital-menu.utils';

export function useBasketQr(tenantId: string, lines: DigitalMenuBasketLine[]) {
  const [result, setResult] = useState({ source: '', image: '', error: '' });
  let source = '';
  let error = '';
  try { if (lines.length) source = encodeBasketQr(tenantId, lines); }
  catch { error = 'הסל גדול מדי לקוד אחד. יש לפצל את הבחירה.'; }
  useEffect(() => {
    if (!source) return;
    let cancelled = false;
    QRCode.toDataURL(source, { width: 768, margin: 4, errorCorrectionLevel: 'L' })
      .then((image) => { if (!cancelled) setResult({ source, image, error: '' }); })
      .catch(() => { if (!cancelled) setResult({ source, image: '', error: 'יצירת הקוד נכשלה' }); });
    return () => { cancelled = true; };
  }, [source]);
  return { image: result.source === source ? result.image : '', error: error || (result.source === source ? result.error : '') };
}